import React from "react";
import { Box, Typography } from "@mui/material";
import aboutUsStyle from "./aboutUsStyle";
import teamMembers from "./components/teamMembers";
import TeamMember from "./components/TeamMember";
import TeamCarousel from "./components/TeamCarousel";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const AboutUs = () => {
  const classes = aboutUsStyle();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box id= "about-us"  className={classes.container}>

      {/* Title */}
      <Typography variant="h4" className={classes.title}>
        Meet the Team
      </Typography>

      {/* Paragraph */}
      <Typography variant="body1" className={classes.paragraph}>
        We are a team of designers and technologists reimagining the area of Paketposthalle with innovative and sustainable solutions. 
        Get to know the minds behind our vision and explore the passion driving our work.
      </Typography>

      {/* Team members */}
      {isMobile ? (
        <TeamCarousel teamMembers={teamMembers} />
      ) : (
        <Box className={classes.teamRow}>
          {teamMembers.map((member, index) => (
            <TeamMember key={index} member={member} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default AboutUs;